/**
 * Post-Singularity Collaboration Terminal Modal
 * Displays creator credentials and direct communication terminal.
 */

export class TerminalModal {
  public init(): void {
    const modal = document.createElement('div');
    modal.id = 'terminal-modal';
    modal.className = 'hidden fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-950/80 backdrop-blur-2xl';

    modal.innerHTML = `
      <div class="bg-neutral-900/95 border border-amber-500/30 rounded-2xl max-w-xl w-full p-6 text-neutral-200 font-mono shadow-2xl shadow-amber-900/20 relative">
        <!-- Close Button -->
        <button id="modal-close" class="absolute top-4 right-4 text-neutral-500 hover:text-neutral-200 text-lg transition-colors">
          ✕
        </button>

        <!-- Header -->
        <div class="flex items-center space-x-3 mb-4 pb-3 border-b border-neutral-800">
          <span class="w-3 h-3 rounded-full bg-emerald-500 animate-ping"></span>
          <div>
            <div class="text-xs text-amber-500 font-semibold uppercase tracking-wider">Direct Collaboration Terminal</div>
            <div class="text-base font-bold text-neutral-100">ALEXANDER VEX // ARCHITECT</div>
          </div>
        </div>

        <!-- Terminal Output -->
        <div class="bg-neutral-950/80 rounded-xl p-4 border border-neutral-800 text-xs space-y-3 mb-5 max-h-60 overflow-y-auto">
          <p class="text-neutral-400">
            <span class="text-emerald-400">[SYSTEM]</span> Architecture verified. 120Hz physics engine, zero GC memory pool, procedural Web Audio synth loaded cleanly.
          </p>
          <p class="text-neutral-300 leading-relaxed">
            "Human curiosity is not a passive spectator in a dark universe, but the active kinetic engine capable of transforming chaos into light, weight into movement, and complexity into eternal simplicity."
          </p>
          <div class="p-3 bg-amber-500/10 border border-amber-500/20 rounded-lg text-amber-300">
            <span class="font-bold">STATUS:</span> Open for high-impact principal engineering, technical direction, and award-winning interactive exhibition architectures.
          </div>
        </div>

        <!-- Contact Action -->
        <div class="flex flex-col sm:flex-row gap-3">
          <a href="mailto:alexander@vex.digital" class="flex-1 bg-amber-500 hover:bg-amber-400 text-neutral-950 font-bold py-3 px-4 rounded-xl text-center text-xs transition-colors flex items-center justify-center space-x-2">
            <span>✉️</span>
            <span>INITIATE COLLABORATION VIA EMAIL</span>
          </a>
          <button id="modal-close-btn" class="bg-neutral-800 hover:bg-neutral-700 text-neutral-300 font-medium py-3 px-4 rounded-xl text-xs transition-colors">
            RETURN TO EXHIBITION
          </button>
        </div>
      </div>
    `;

    document.body.appendChild(modal);

    // Bind Close Handlers
    const closeBtn = document.getElementById('modal-close');
    const closeBtn2 = document.getElementById('modal-close-btn');

    const closeModal = () => modal.classList.add('hidden');

    closeBtn?.addEventListener('click', closeModal);
    closeBtn2?.addEventListener('click', closeModal);
    modal.addEventListener('click', (e) => {
      if (e.target === modal) closeModal();
    });
  }
}
